import { render, staticRenderFns } from "./CozeChat.vue?vue&type=template&id=6d3fb1a6&scoped=true&"
import script from "./CozeChat.vue?vue&type=script&lang=js&"
export * from "./CozeChat.vue?vue&type=script&lang=js&"
import style0 from "./CozeChat.vue?vue&type=style&index=0&id=6d3fb1a6&prod&scoped=true&lang=css&"
import style1 from "./CozeChat.vue?vue&type=style&index=1&id=6d3fb1a6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3fb1a6",
  null
  
)

export default component.exports